// Preload critical font (Regular) and defer-load other weights using FontFace API

// Use webpack to resolve asset URLs
// eslint-disable-next-line
const REGULAR_URL = require('@/common/alibaba-puhuiti-regular-webfont.woff');
// eslint-disable-next-line
const LIGHT_URL = require('@/common/alibaba-puhuiti-light-webfont.woff');
// eslint-disable-next-line
const MEDIUM_URL = require('@/common/alibaba-puhuiti-medium-webfont.woff');
// eslint-disable-next-line
const BOLD_URL = require('@/common/alibaba-puhuiti-bold-webfont.woff');
// eslint-disable-next-line
// const HEAVY_URL = require('@/common/alibaba-puhuiti-heavy-webfont.woff');

export function preloadCriticalFonts () {
  // note: 原本 LCP 3.73 - 查看预加载 font 的影响 -> 3.69
  // try {
  //   const link = document.createElement('link');
  //   link.rel = 'preload';
  //   link.as = 'font';
  //   link.href = REGULAR_URL;
  //   link.type = 'font/woff';
  //   link.crossOrigin = 'anonymous';
  //   document.head.appendChild(link);
  // } catch (e) {
  //   // noop
  // }
}

export function deferNonCriticalFonts () {
  if (!(window.FontFace)) return;
  const defs = [
    { family: 'PuHuiTiLight', url: LIGHT_URL },
    { family: 'PuHuiTiMedium', url: MEDIUM_URL },
    { family: 'PuHuiTiBold', url: BOLD_URL },
    // { family: 'PuHuiTiHeavy', url: HEAVY_URL }
  ];

  defs.forEach(({ family, url }) => {
    try {
      const ff = new FontFace(
        family,
        `url(${url}) format('woff')`,
        /** @type {any} */ ({
          style: 'normal',
          weight: 'normal',
          display: 'swap',
          sizeAdjust: '107.5%',
          ascentOverride: '85%',
          descentOverride: '20%',
          lineGapOverride: '0%'
        })
      );
      ff.load().then((loaded) => {
        document.fonts.add(loaded);
        // Trigger relayout for elements using this family
        document.documentElement.style.fontKerning = 'normal';
      }).catch(() => { });
    } catch (e) {
      // ignore
    }
  });
}

export function scheduleDeferFonts () {
  const schedule = window.requestIdleCallback || function (cb) { return setTimeout(cb, 2000); };
  schedule(() => deferNonCriticalFonts());
}
